import { render, staticRenderFns } from "./goods-price.vue?vue&type=template&id=30fea848&scoped=true"
import script from "./goods-price.vue?vue&type=script&lang=js"
export * from "./goods-price.vue?vue&type=script&lang=js"
import style0 from "./goods-price.vue?vue&type=style&index=0&id=30fea848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fea848",
  null
  
)

export default component.exports